import axios from 'axios';

const hrAxios = axios.create({
  baseURL: 'https://hr.al-ahmari.com.sa/server/api/',
  timeout: 10000,
});

// Add a request interceptor to include the token if needed
hrAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default hrAxios;
